import Construction from 'src/assets/InsuranceSpotlightImages/Infra/Construction.svg'
import Debris_Coverage from 'src/assets/InsuranceSpotlightImages/Fire/Debris_Coverage.svg'

const INSURANCE_SPOTLIGHT_DATA = {
  general: {
    data: null,
    youtubeLinks: [
      {
        type: 'General',
        title: 'Mental health',
        link: 'https://www.youtube.com/embed/2lAskocDczE?si=XVAlCpUDwYwCr9_b',
        imageLink: 'https://www.youtube.com/watch?v=2lAskocDczE',
      },
      {
        type: 'General',
        title:// prettier-ignore
         'Insurance\'s Golden Rule ~ BE HONEST',
        link: 'https://www.youtube.com/embed/juiHJpufVNo?si=YKhjCjOOHnHVmSYo',
        imageLink: 'https://www.youtube.com/watch?v=juiHJpufVNo&t=1s',
      },
      {
        type: 'General',
        title: 'MUST WATCH "DON\'T BUY ANY INSURANCE',
        link: 'https://www.youtube.com/embed/5KGB-u4C1jg?si=cc4nVQeUNgKbMbKp',
        imageLink: 'https://www.youtube.com/watch?v=5KGB-u4C1jg',
      },
    ],
  },
  generalClaims: {
    data: null,
    youtubeLinks: [
      {
        type: 'Claims',
        title: 'IRDAI Circular on Arbitration',
        link: 'https://www.youtube.com/embed/8Tc_CE_deNE?si=jMcj_QdT5BbP18e3',
        imageLink: 'https://www.youtube.com/watch?v=8Tc_CE_deNE',
      },
      {
        type: 'Claims',
        title: 'Who Is This Nodal Officer? Part - 1',
        link: 'https://www.youtube.com/embed/Lhrh3ABPV9w?si=WHHKs5z7HyhNeRVa',
        imageLink: 'https://www.youtube.com/watch?v=Lhrh3ABPV9w&t=6s',
      },
      {
        type: 'Claims',
        title: 'The Saviour Of Policyholders* OMBUDSMAN Part - 2',
        link: 'https://www.youtube.com/embed/yZwHWW1fIek?si=pAmCUovAOZ_zvp2l',
        imageLink: 'https://www.youtube.com/watch?v=yZwHWW1fIek',
      },
    ],
  },
  hrHealth: {
    data: null,
    youtubeLinks: [
      {
        type: 'HR',
        title: 'Thank God You Are Not Hospitalized',
        link: 'https://www.youtube.com/embed/8urabq4s490?si=PkQVES1YtTJSgX22',
        imageLink: 'https://www.youtube.com/watch?v=8urabq4s490',
      },
      {
        type: 'HR',
        title: '*IT IS IMPORTANT* PARENTAL HEALTH INSURANCE',
        link: 'https://www.youtube.com/embed/o1Qvus4Rd0I?si=413GVVTdmH82J1Nz',
        imageLink: 'https://www.youtube.com/watch?v=o1Qvus4Rd0I&t=6s',
      },
      {
        type: 'HR',
        title:
          'Boost your Health Insurance coverage with Top up Insurance * | MadOverInsurance',
        link: 'https://www.youtube.com/embed/XtHg1xzt0xQ?si=pGO1vVLvmx-kaxsQ',
        imageLink: 'https://www.youtube.com/watch?v=XtHg1xzt0xQ&t=6s',
      },
    ],
  },
  infra: {
    data: [
      {
        id: '10001',
        image: Construction,
        storyTitle: 'Contractor’s Plant and Machinery policy',
        storyHeading: 'Understanding Policy Coverage',
        scenario: {
          title:
            'A contractor bought a Contractor’s Plant and Machinery policy for their Tower Crane.',
          firstExplanation: (
            <>
              <span className='underLined-text'>
                They had clearly informed the insurer that the Tower Crane will
                be moving from one project site to a different project site
                whenever needed.
              </span>{' '}
              They gave the address of both the project sites to the insurer.
            </>
          ),
          secondExplanation: (
            <>
              While taking the crane from one site to another, they dismantled
              the crane, took it to the other site and re-erected at the second
              site.{' '}
              <span className='underLined-text'>
                While re-erecting at the second site, the support of the crane
                was broken due to which the climbing frame broke.
              </span>
            </>
          ),
          details: (
            <>
              The insurer refused to pay the claim saying that the Crane was not
              yet commissioned and they{' '}
              <span className='highlight-color'>
                should have bought a Erection All Risk policy
              </span>{' '}
              for re-erection of the crane.{' '}
              <span className='highlight-color'>Insured felt cheated.</span>
            </>
          ),
        },
        lesson:
          'Use a professional broker who have experience in handling claims so that proper advice can be availed at the time of buying policy so that there are no surprises at the time of claim.',
      },
    ],
    youtubeLinks: [
      {
        type: 'Infra',
        title: 'Surety Bond Insurance for Infrastructure Projects',
        link: 'https://www.youtube.com/embed/95WmhaSQuck?si=xAo1YZml71DR_KA3',
        imageLink: 'https://www.youtube.com/watch?v=95WmhaSQuck&t=5s',
      },
      {
        type: 'Infra',
        title: 'Project Insurance',
        link: 'https://www.youtube.com/embed/FZuTnN5MAjY?si=qbWv2Q41GgqGBTeU',
        imageLink: 'https://www.youtube.com/watch?v=FZuTnN5MAjY',
      },
      {
        type: 'Infra',
        title: 'How is large risk shared amongst Insurers & Re-Insurers',
        link: 'https://www.youtube.com/embed/dVHYGVMFg2w?si=9VJ4SUYsCXAsfQlI',
        imageLink: 'https://www.youtube.com/watch?v=dVHYGVMFg2w&t=434s',
      },
    ],
  },
  fire: {
    data: [
      {
        id: '10001',
        image: Debris_Coverage,
        storyTitle: 'Fire Insurance: A Power Plant Company Story.',
        storyHeading: 'Removal of Debris Coverage',
        scenario: {
          title: (
            <>
              A company operating a hydropower plant in the Himalayan belt
              purchased a Fire Policy.
            </>
          ),
          firstExplanation: (
            <>
              During a cloud burst and heavy{' '}
              <span className='underLined-text'>
                flooding, the powerhouse was inundated with floodwaters carrying
                mud, tree branches, and boulders.
              </span>
            </>
          ),
          secondExplanation: (
            <>
              The policy included an extension for{' '}
              <span className='underLined-text'>“Removal of Debris”</span>{' '}
              capped at <span className='underLined-text'>Rs 5 crores.</span>{' '}
              Post the flood, the cost to clear the debris settled in the
              powerhouse amounted to Rs 1 crore to the company.
            </>
          ),
          details: (
            <>
              However, the{' '}
              <span className='highlight-color'>insurer refused </span> to cover
              this cost, citing that the debris was categorized as “Foreign
              Debris,” not covered under the policy’s clause of “Debris of
              Insured Property.”{' '}
              <div className='highlight-color-text'>
                This left the company feeling deceived.
              </div>
            </>
          ),
        },
        lesson:
          'Engage a seasoned insurance broker to guide during policy purchase, ensuring comprehensive advice and avoiding surprises during claims.',
      },
    ],
    youtubeLinks: [],
  },
  allBusiness: {
    data: null,
    youtubeLinks: [
      {
        type: 'All Business',
        title: 'Loss of Profit Insurance',
        link: 'https://www.youtube.com/embed/yZ6L4Npo7sQ?si=GVu9eMCArd9T4T84',
        imageLink: 'https://www.youtube.com/watch?v=yZ6L4Npo7sQ&t=477s',
      },
      {
        type: 'All Business',
        title: 'CECR Insurance',
        link: 'https://www.youtube.com/embed/seoqr778vXw?si=v1HdPrU9T-PIlCQe',
        imageLink: 'https://www.youtube.com/watch?v=seoqr778vXw&t=3s',
      },
      {
        type: 'All Business',
        title: 'Adequate sum insured in insurance',
        link: 'https://www.youtube.com/embed/v9KVXVRyruU?si=CHFUCZT8zR3sKMTB',
        imageLink: 'https://www.youtube.com/watch?v=v9KVXVRyruU&t=19s',
      },
      {
        type: 'All Business',
        title: 'Travel Insurance',
        link: 'https://www.youtube.com/embed/ZA_mpBhANIo?si=c5-3X8uJ_388PAH7',
        imageLink: 'https://www.youtube.com/watch?v=ZA_mpBhANIo',
      },
      {
        type: 'All Business',
        title: 'Room rent capping in health insurance',
        link: 'https://www.youtube.com/embed/cMlVtDr4-hE?si=j5TKMjRFtgaRNt2F',
        imageLink: 'https://www.youtube.com/watch?v=cMlVtDr4-hE',
      },
      {
        type: 'All Business',
        title: 'Case study of portable fire ',
        link: 'https://www.youtube.com/embed/a1BCCu9jKPc?si=7ugdLlsM_uHkqkaR',
        imageLink: 'https://www.youtube.com/watch?v=a1BCCu9jKPc',
      },
      {
        type: 'All Business',
        title: 'Under Insurance Concept',
        link: 'https://www.youtube.com/embed/aIOtY9QtPa0?si=PhJEkyNZsu6onqQw',
        imageLink: 'https://www.youtube.com/watch?v=aIOtY9QtPa0',
      },
    ],
  },
}

const SPOTLIGHT_TAB_TYPES = {
  FIRE: 'fire',
  INFRA: 'infra',
  HR: 'hrHealth',
  CLAIMS: 'generalClaims',
  GENERAL: 'general',
  ALL: 'allBusiness',
}

const SPOTLIGHT_TABS = [
  {
    label: 'Fire',
    type: SPOTLIGHT_TAB_TYPES.FIRE,
  },
  {
    label: 'Infra',
    type: SPOTLIGHT_TAB_TYPES.INFRA,
  },
  {
    label: 'HR',
    type: SPOTLIGHT_TAB_TYPES.HR,
  },
  {
    label: 'Claims',
    type: SPOTLIGHT_TAB_TYPES.CLAIMS,
  },
  {
    label: 'General',
    type: SPOTLIGHT_TAB_TYPES.GENERAL,
  },
]

export { INSURANCE_SPOTLIGHT_DATA, SPOTLIGHT_TABS, SPOTLIGHT_TAB_TYPES }

// {
//   data: [
//       {
//         id: '10001',
//         image: null,
//         storyTitle: ``,
//         storyHeading: ``,
//         scenario: {
//           title: ``,
//           firstExplanation: ``,
//           secondExplanation: ``,
//           details: ``,
//         },
//         lesson: ``,
//       },
//     ],,
//   youtubeLinks: [
//     {
//       title: ``,
//       link: ``,
//     },
//   ],
// }
